/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliPeriodDto } from '../../models/amoxcalli-period-dto';

export interface ApiCyclesCycleIdPeriodsGet$Plain$Params {
  cycleId: string;
}

export function apiCyclesCycleIdPeriodsGet$Plain(http: HttpClient, rootUrl: string, params: ApiCyclesCycleIdPeriodsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AmoxcalliPeriodDto>>> {
  const rb = new RequestBuilder(rootUrl, apiCyclesCycleIdPeriodsGet$Plain.PATH, 'get');
  if (params) {
    rb.path('cycleId', params.cycleId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AmoxcalliPeriodDto>>;
    })
  );
}

apiCyclesCycleIdPeriodsGet$Plain.PATH = '/api/cycles/{cycleId}/periods';
